var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{ref:"header",attrs:{"title":_vm.$route.meta.title,"table-name":_vm.tableName}}),_c('Table',{ref:"table",attrs:{"table-name":_vm.tableName,"disable-pagination":""},on:{"contextMenu":_vm.openContextMenu}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }